import Link from 'next/link';
export default function AdminAccess({ session, loading }) {
	return (
		<ul className="flex space-x-8 " data-sentry-component="AdminAccess" data-sentry-source-file="index.jsx">
			{!session && !loading && (
				<li>
					<Link href="/login">Admin</Link>
				</li>
			)}
			{session && (
				<>
					<li>
						<Link href="/dashboard">Dashboard</Link>
					</li>
					<li>
						<Link href="/application/family/new">
							New Family App
						</Link>
					</li>
					<li>
						<Link href="/application/senior/new">
							New Senior App
						</Link>
					</li>
					<li>
						<button
							onClick={async () => await window.Clerk.signOut()}
						>
							Logout
						</button>
					</li>
				</>
			)}
		</ul>
	);
}
